<script>
  import { mapState, mapActions } from 'vuex'
  import { TopBar, LoadingOverlay } from '@/components/_shared'
  import { AppStoreFeatured, AppStoreGrid } from '@/components/app-store'

  export default {
    name: 'app-store-view',

    components: {
      TopBar,
      LoadingOverlay,
      AppStoreFeatured,
      AppStoreGrid
    },

    metaInfo: {
      title: 'App Store'
    },

    computed: {
      ...mapState('appStore', {
        groups: state => state.apps,
        loading: state => state.loading
      })
    },

    methods: {
      ...mapActions('appStore', [
        'loadApps',
        'clearApps'
      ])
    },

    created () {
      this.loadApps()
    },

    destroyed () {
      this.clearApps()
    }
  }
</script>

<template>
  <div class="app-store">
    <top-bar title="App Store" icon="store"/>
    <loading-overlay :is-loading="loading">
      <app-store-featured/>
      <app-store-grid :groups="groups"/>
    </loading-overlay>
  </div>
</template>

<style src="./AppStoreView.scss" lang="scss" scoped></style>
